import React from 'react';
import { ConsultantContactList } from '../components/consultants/ConsultantContactList';
import { GeneralInquiryForm } from '../components/forms/GeneralInquiryForm';
import { ButtonLink } from '../components/ui/ButtonLink';
import { PageHero } from '../components/ui/PageHero';
import { usePageMeta } from '../hooks/usePageMeta';
export function Contact() {
  usePageMeta('Contact Us', 'Contact Aurevane Search Partners to discuss executive hiring needs or introduce yourself as a senior leader. Email our Executive Search Consultants directly.');
  return <>
      <PageHero compact label="Contact Us" title="Let’s Start a Meaningful Conversation." intro="Choose the pathway that fits you best, email a consultant directly, or send a general inquiry below." data-id="element-696" data-mp="17q8q7b0rng6k" />

      <section className="grid md:grid-cols-2" aria-label="Contact pathways" data-id="element-697" data-mp="f8wmwzc1v9fl">
        <div className="bg-limestone px-6 py-16 sm:px-12 lg:py-20 lg:pl-10 xl:pl-[max(2.5rem,calc((100vw-80rem)/2+2.5rem))]" data-id="element-698" data-mp="abwfol3gs0mw">
          <div className="flex h-full max-w-lg flex-col" data-id="element-699" data-mp="15exah7r9q92f">
            <h2 className="text-2xl font-semibold text-aubergine sm:text-3xl" data-id="element-700" data-mp="19gihwdl19v58">For Employers</h2>
            <p className="mt-4 leading-relaxed text-plum/75" data-id="element-701" data-mp="1e78nnrxdg00g">
              Begin a conversation about leadership requirements, confidential searches, board appointments, or wider recruitment needs. We will arrange an initial discussion to understand your situation.
            </p>
            <ButtonLink to="/employers#inquiry" arrow className="mt-8 self-start" data-id="element-702" data-mp="qi6aaw9rstbr">
              Discuss Your Hiring Needs
            </ButtonLink>
          </div>
        </div>
        <div className="border-t border-plum/10 bg-porcelain px-6 py-16 sm:px-12 md:border-l md:border-t-0 lg:py-20 lg:pr-10 xl:pr-[max(2.5rem,calc((100vw-80rem)/2+2.5rem))]" data-id="element-703" data-mp="vjc3ev7ceilt">
          <div className="flex h-full max-w-lg flex-col" data-id="element-704" data-mp="26vmpkirkzgha">
            <h2 className="text-2xl font-semibold text-aubergine sm:text-3xl" data-id="element-705" data-mp="2bv93kuf8h0r5">For Candidates</h2>
            <p className="mt-4 leading-relaxed text-plum/75" data-id="element-706" data-mp="1m73lpq9mh8a7">
              Experienced professionals can introduce their background and aspirations in confidence, for consideration in relevant current and future searches.
            </p>
            <ButtonLink to="/candidates#introduce" variant="dark" arrow className="mt-8 self-start" data-id="element-707" data-mp="1w48c62ai3pwt">
              Introduce Yourself
            </ButtonLink>
          </div>
        </div>
      </section>

      <section className="border-t border-plum/10 bg-porcelain py-20 lg:py-28" data-id="element-708" data-mp="13hdqx35v0mia">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10" data-id="element-709" data-mp="yiu4z2r9napx">
          <div className="lg:col-span-5" data-id="element-710" data-mp="1d6xbcd980of9">
            <h2 className="text-2xl font-semibold text-aubergine" data-id="element-711" data-mp="1d802mmaggsvp">Our consultants</h2>
            <p className="mt-3 leading-relaxed text-plum/70" data-id="element-712" data-mp="18edyjiicxxbi">Email any member of our team directly.</p>
            <div className="mt-8" data-id="element-713" data-mp="koteewagwu0n">
              <ConsultantContactList columns={1} data-id="element-714" data-mp="frb34z8za2ph" />
            </div>
          </div>
          <div className="lg:col-span-6 lg:col-start-7" data-id="element-715" data-mp="fp700jiwl7q9">
            <h2 className="text-2xl font-semibold text-aubergine" data-id="element-716" data-mp="2rdlk3ohc8y60">General inquiry</h2>
            <p className="mt-3 leading-relaxed text-plum/70" data-id="element-717" data-mp="2w5mu13r1acsv">
              For anything else, send us a message. Fields marked <span className="text-copper-deep" data-id="element-718" data-mp="2hhicw47mq9c7">*</span> are required.
            </p>
            <div className="mt-8" data-id="element-719" data-mp="2mes9q4xclna2">
              <GeneralInquiryForm data-id="element-720" data-mp="2mftke8agc7r9" />
            </div>
          </div>
        </div>
      </section>
    </>;
}